import { AxiosError } from 'axios';
import { extendSession, login, logout } from './api';
import { ErrorResponse, LoginRequest, LoginResponse } from './types';

export * from './api';
export * from './types';

/**
 * Authentication API service
 */
export const authService = {
  /**
   * Login with email and password
   * @param credentials - Login credentials (email and password)
   * @returns Promise with login response data
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await login(credentials);
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError<ErrorResponse>['response'];
      throw new Error(axiosError?.data?.detail);
    }
  },

  /**
   * Продлевает текущую сессию: работа продолжается без повторного входа.
   * Отказ пробрасывается вызывающему — отсчёт до конца сессии продолжается.
   */
  async extendSession(): Promise<void> {
    await extendSession();
  },

  /**
   * Logout current user.
   */
  async logout(): Promise<void> {
    try {
      await logout();
    } catch {
      // Best-effort: server notification failed
    }
  },
};
